import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {connect} from "react-redux";
import {useToaster} from "@gravity-ui/uikit";

import ApplicationForm from "./ApplicationForm";
import {
    getAcceptAuthConfig,
    getJSONConfig,
    USER_APPLICATIONS_ENDPOINT,
    WORKSHOPS_INFO_ENDPOINT
} from "../../../api/api";
import {checkProfileForWorkshop} from "../../../utils/profileValidation";

function ApplicationFormCreate({user}) { // Добавляем user в пропсы
    const navigate = useNavigate();
    const {add: addToast} = useToaster();
    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState(null);
    const [activeWorkshop, setActiveWorkshop] = useState(null);

    const [applicationData, setApplicationData] = useState(() => (localStorage.getItem('application') ?
        JSON.parse(localStorage.getItem('application')) :
        {
            education: "",
            experience: "",
            achievements: "",
            achievements_confirmation_file: "",
            skills: "",
            scientific_interests: "",
            expectations: "",
            other_comments: ""
        }));

    const [applicationProjectsData, setApplicationProjectsData] = useState(() => {
        console.log('Initializing application projects data...');
        const applicationProjects = JSON.parse(localStorage.getItem('applicationProjects')) || [];
        const addedProjects = JSON.parse(localStorage.getItem('addedProjects')) || [];
        let newProjects = [];

        const fetchActiveWorkshop = async () => {
            try {
                const response = await axios.get(WORKSHOPS_INFO_ENDPOINT, {
                    params: { is_active: "True" },
                    headers: getJSONConfig().headers,
                });

                if (response.data.length > 0) {
                    const activeWorkshopData = response.data[0];
                    setActiveWorkshop(activeWorkshopData);

                    const activeWorkshopId = activeWorkshopData.id;

                    newProjects = addedProjects.filter(
                        project => project.workshop && project.workshop.id === activeWorkshopId
                    );

                    const filteredProjects = [...applicationProjects, ...newProjects];
                    setApplicationProjectsData(filteredProjects);
                }
            } catch (error) {
                console.error('Ошибка получения данных мастерской:', error);
            }
        };

        fetchActiveWorkshop();

        return applicationProjects;
    });

    useEffect(() => {
        localStorage.setItem('application', JSON.stringify(applicationData));
    }, [applicationData]);

    useEffect(() => {
        localStorage.setItem('addedProjects', JSON.stringify(applicationProjectsData));
    }, [applicationProjectsData]);

    const onSubmit = (e) => {
        e.preventDefault();

        if (user && activeWorkshop) {
            let workshopYear = 2026;
            if (activeWorkshop.year) {
                workshopYear = activeWorkshop.year;
            } else if (activeWorkshop.start_date) {
                workshopYear = new Date(activeWorkshop.start_date).getFullYear();
            }

            const { isValid, message } = checkProfileForWorkshop(user, workshopYear);

            if (workshopYear >= 2026 && !isValid) {
                addToast({
                    name: 'profile-incomplete',
                    title: 'Профиль не заполнен',
                    content: message,
                    theme: 'warning',
                    autoHiding: false,
                    actions: [{
                        label: 'Перейти в профиль',
                        onClick: () => navigate('/account/settings'),
                    }],
                });
                return;
            }
        }

        if (applicationProjectsData.length < 3) {
            addToast({
                name: 'projects-min',
                title: 'Недостаточно проектов',
                content: `Выберите не менее 3 проектов. Сейчас выбрано: ${applicationProjectsData.length}.`,
                theme: 'warning',
                autoHiding: 6000,
            });
            return;
        }

        setSubmitting(true);

        const formData = new FormData();

        formData.append("cv", JSON.stringify(applicationData));
        formData.append("achievements_confirmation_file", applicationData.achievements_confirmation_file);

        formData.append("projects_user", JSON.stringify(applicationProjectsData));
        applicationProjectsData.forEach(project => {
            if (project.file) {
                formData.append(project.id, project.file);
            }
        });

        axios
            .post(USER_APPLICATIONS_ENDPOINT, formData, getAcceptAuthConfig())
            .then(response => {
                localStorage.removeItem('application');
                navigate('../', {relative: "path"});
            })
            .catch(error => {
                setErrors(error.response?.data)
                console.error('Ошибка отправки заявки:', error);
            })
            .finally(() => {
                setSubmitting(false);
            });
    }

    return (
        <>
            <h3 className="mb-2">Подача заявки на участие</h3>
            <hr className="clearfix w-100 pb-0"/>

            <ApplicationForm type={"create"}
                             applicationData={applicationData} setApplicationData={setApplicationData}
                             applicationProjectsData={applicationProjectsData}
                             setApplicationProjectsData={setApplicationProjectsData}
                             errors={errors}
                             onSubmit={onSubmit} submitting={submitting}/>
        </>
    );
}

const mapStateToProps = state => ({
    user: state.auth.user,
});

export default connect(mapStateToProps)(ApplicationFormCreate);